module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"text":{"chrome":"Über die Chrome-Einstellungen können Sie über die Funktion \\"Zum Startbildschirm zufügen\\" einen Direktlink zum Portal anlegen.","ios":"Über die Teilen-Funktion zu Ihrem Home-Bildschirm hinzufügen"},"title":"Schnellzugriff einrichten!"}}')
  delete Component.options._Ctor
}
